/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Instruction } from './Instruction'
import {
  InstructionFromJSON,
  InstructionFromJSONTyped,
  InstructionToJSON,
} from './Instruction'

/**
 *
 * @export
 * @interface GetInstruction200Response
 */
export interface GetInstruction200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetInstruction200Response
   */
  status: boolean
  /**
   *
   * @type {Instruction}
   * @memberof GetInstruction200Response
   */
  data: Instruction
}

/**
 * Check if a given object implements the GetInstruction200Response interface.
 */
export function instanceOfGetInstruction200Response(
  value: object
): value is GetInstruction200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetInstruction200ResponseFromJSON(
  json: any
): GetInstruction200Response {
  return GetInstruction200ResponseFromJSONTyped(json, false)
}

export function GetInstruction200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetInstruction200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: InstructionFromJSON(json['data']),
  }
}

export function GetInstruction200ResponseToJSON(
  value?: GetInstruction200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: InstructionToJSON(value['data']),
  }
}
